import React from 'react';
import type { CachedRecipe } from '@recipe-rack/shared';

import { Button } from '../../design/components';

interface TrendingCardProps {
  cached: CachedRecipe;
  onSave: () => void;
}

const hostnameOf = (url: string): string => {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
};

const TrendingCard: React.FC<TrendingCardProps> = ({ cached, onSave }) => (
  <article className="rr-trendingcard">
    <div className="rr-trendingcard-meta">
      <span>{hostnameOf(cached.url)}</span>
      <span aria-hidden="true">·</span>
      <span>
        {cached.ingredients.length} ingredient
        {cached.ingredients.length === 1 ? '' : 's'}
      </span>
    </div>
    <h3 className="rr-trendingcard-title">{cached.title}</h3>
    <div className="rr-trendingcard-foot">
      <span className="rr-trendingcard-saves">
        Saved {cached.saveCount}×
      </span>
      <Button size="sm" variant="tomato" onClick={onSave}>
        Save to my rack
      </Button>
    </div>
  </article>
);

export default TrendingCard;
